module.exports = __webpack_public_path__ + "img/Ashok_Kumar_Mohapatra.ea259fe9.jpg";